import axios from "axios";
import {baseURL} from "./baseURL";


export const axiosInstances = axios.create({
     baseURL: baseURL
})